<template>
  <router-link :to="to || '#'" class="cta">
    <SVGChevronDownLeft />
    <span>
      <slot />
    </span>
    <SVGChevronUpRight />
  </router-link>
</template>

<script>
  import SVGChevronDownLeft from '@/assets/svg/icon-chevron-down-left.svg?inline';
  import SVGChevronUpRight from '@/assets/svg/icon-chevron-up-right.svg?inline';

  export default {
    name: 'CTA',
    components: {
      SVGChevronDownLeft,
      SVGChevronUpRight,
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {
      to: {
        type: String,
        default: null,
      },
    },
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {};
    },
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {},
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {},
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    // filters: {},
    //---------------------------------------------------
    //
    //  Validation Properties
    //
    //---------------------------------------------------
    // validations: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {},
  };
</script>

<style lang="scss">
@import '~scss/mixins';
@import '~scss/variables';

a.cta {
  flex-grow: unset;
  position: relative;
  background: transparent;
  outline: 0;
  border: 0;
  float: right;
  cursor: pointer;
  @include font-regular;
  font-size: 1.8rem;
  margin-top: 10px;
  padding: 10px 0;
  display: inline-block;
  color: inherit;
  text-decoration: none;

  & > svg {
    position: relative;
    top: 50%;
    opacity: 0.25;
    transition: opacity $default-transition, transform $default-transition;

    &:first-of-type {
      transform: translate(-2.5px, calc(50% + 2.5px));
    }
    &:last-of-type {
      transform: translate(2.5px, -2.5px);
    }
  }

  &:hover {
    & > svg {
      opacity: 1;
      &:first-of-type {
        transform: translate(2.5px, 50%);
      }
      &:last-of-type {
        transform: translate(-2.5px, 0);
      }
    }
  }
}

</style>
